import { SearchParameter } from './review/search-parameter.model';
import { SearchReportQuery } from './search-report-query.model';

export class SearchReport {
  searchReportId: string;
  caseId: string;
  title: string;
  createdById: string;
  dateTimeCreated: string;
  dateTimeRun: string;
  runStatus: SearchReportStatus;
  filterId: string;
  searchParameter: SearchParameter;
  searchReportQueries: SearchReportQuery[];
}

export enum SearchReportStatus {
  Created = 'Created',
  Running = 'Running',
  Done = 'Done',
  Error = 'Error'
}
